

// import React, { useState } from "react";
// import AttendanceLoader from "./AttendanceLoader";
// import "../styles/AttendanceReport.css";

// function AttendanceUpload({ onUploadSuccess }) {
//   const [loading, setLoading] = useState(false);

//   const handleUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       setLoading(true);

//       // Helper to strip BOM / leading garbage before JSON.parse
//       const parseJsonSafe = (text) => {
//         const jsonStart = text.search(/[\{\[]/);
//         if (jsonStart !== -1) {
//           return JSON.parse(text.substring(jsonStart));
//         }
//         return JSON.parse(text);
//       };

//       // ✅ Upload
//       const uploadRes = await fetch("/gt-api/upload_attendance.php", {
//         method: "POST",
//         body: formData
//       });

//       const uploadText = await uploadRes.text();
//       let uploadData;
//       try {
//         uploadData = parseJsonSafe(uploadText);
//       } catch (err) {
//         console.error("Upload Response is not JSON:", uploadText);
//         alert("Upload Server Error: " + uploadText.substring(0, 150));
//         return;
//       }

//       console.log("UPLOAD RESPONSE:", uploadData);

//       // ❌ Stop if upload failed
//       if (uploadData.error) {
//         alert(uploadData.error);
//         return;
//       }

//       // ✅ Process
//       const processRes = await fetch(
//         `/gt-api/process_attendance.php`
//       );
//       const processText = await processRes.text();
//       let processData;
//       try {
//         processData = parseJsonSafe(processText);
//       } catch (err) {
//         console.error("Process Response is not JSON:", processText);
//         alert("Processing Server Error: " + processText.substring(0, 150));
//         return;
//       }

//       console.log("PROCESS RESPONSE:", processData);

//       if (processData.error) {
//         alert(processData.error);
//         return;
//       }

//       // 🔥 notify parent
//       if (onUploadSuccess) {
//         onUploadSuccess();
//       }

//     } catch (error) {
//       console.error("Error:", error);
//       alert("Failed ❌ " + (error.message || ""));
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <AttendanceLoader 
//         message="Uploading & Processing Attendance File..." 
//         subtitle="Please wait while we parse Excel records, calculate break durations, and process late marks." 
//       />
//     );
//   }

//   return (
//     <div style={{ marginBottom: "20px", padding: "20px" }}>
//       <h3>Upload Attendance File</h3>

//       {/* File Upload */}
//       <input
//         type="file"
//         accept=".csv,.xlsx,.xls"
//         onChange={handleUpload}
//         disabled={loading}
//         style={{ padding: "10px", marginTop: "10px" }}
//       />
//     </div>
//   );
// }

// export default AttendanceUpload;






















import React, { useState } from "react";
import { UploadCloud, FileSpreadsheet, CheckCircle2 } from "lucide-react";
import AttendanceLoader from "./AttendanceLoader";
import "../styles/AttendanceReport.css";

function AttendanceUpload({ onUploadSuccess }) {
  const [loading, setLoading] = useState(false);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);

      // Helper to strip BOM / leading garbage before JSON.parse
      const parseJsonSafe = (text) => {
        const jsonStart = text.search(/[\{\[]/);
        if (jsonStart !== -1) {
          return JSON.parse(text.substring(jsonStart));
        }
        return JSON.parse(text);
      };

      // ✅ Upload
      const uploadRes = await fetch("/gt-api/upload_attendance.php", {
        method: "POST",
        body: formData
      });

      const uploadText = await uploadRes.text();
      let uploadData;
      try {
        uploadData = parseJsonSafe(uploadText);
      } catch (err) {
        console.error("Upload Response is not JSON:", uploadText);
        alert("Upload Server Error: " + uploadText.substring(0, 150));
        return;
      }

      console.log("UPLOAD RESPONSE:", uploadData);

      // ❌ Stop if upload failed
      if (uploadData.error) {
        alert(uploadData.error);
        return;
      }

      // ✅ Process
      const processRes = await fetch(
        `/gt-api/process_attendance.php`
      );
      const processText = await processRes.text();
      let processData;
      try {
        processData = parseJsonSafe(processText);
      } catch (err) {
        console.error("Process Response is not JSON:", processText);
        alert("Processing Server Error: " + processText.substring(0, 150));
        return;
      }

      console.log("PROCESS RESPONSE:", processData);

      if (processData.error) {
        alert(processData.error);
        return;
      }

      // 🔥 notify parent
      if (onUploadSuccess) {
        onUploadSuccess();
      }

    } catch (error) {
      console.error("Error:", error);
      alert("Failed ❌ " + (error.message || ""));
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <AttendanceLoader
        message="Uploading & Processing Attendance File..."
        subtitle="Please wait while we parse Excel records, calculate break durations, and process late marks."
      />
    );
  }

  return (
    <div className="attendance-upload-container">
      <div className="attendance-upload-card">
        <div className="upload-icon-circle">
          <UploadCloud size={38} className="upload-icon-pulse" />
        </div>
        
        <h3 className="upload-card-title">Upload Monthly Attendance Sheet</h3>
        <p className="upload-card-desc">
          Select or drop your employee punch log file to automatically compile monthly statistics and rule infractions.
        </p>

        <div className="upload-format-tags">
          <span className="format-tag"><FileSpreadsheet size={13} /> .XLSX</span>
          <span className="format-tag"><FileSpreadsheet size={13} /> .XLS</span>
          <span className="format-tag"><FileSpreadsheet size={13} /> .CSV</span>
        </div>

        <label className="upload-file-label">
          <input
            type="file"
            accept=".csv,.xlsx,.xls"
            onChange={handleUpload}
            disabled={loading}
            className="upload-file-input-hidden"
          />
          <span className="upload-choose-btn">
            <UploadCloud size={18} /> Select File to Upload
          </span>
        </label>

        {/* <div className="upload-footer-hint">
          <CheckCircle2 size={14} color="#22c55e" />
          <span>Automatic date range detection & late mark processing</span>
        </div> */}
      </div>
    </div>
  );
}

export default AttendanceUpload;